var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.init)?_c('div',{attrs:{"id":"app"}},[(!_vm.hideNav)?_c('TopNav'):_vm._e(),_c('div',{staticClass:"content"},[_c('router-view')],1),(!_vm.hideFooter)?_c('WebFooter'):_vm._e(),_c('Transition',{attrs:{"name":"fade"}},[(_vm.isStoreBusy)?_c('div',{staticClass:"loading-mask"},[_c('b-spinner')],1):_vm._e()])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }